/* eslint-disable global-require, max-len, quote-props */
module.exports = {


  'pbauthentication': {
    '1.0': {
      'authenticate-pbOnline': require('./pbauthentication/1.0/authenticate-pbOnline/success.json'),
      'change-password-pbOnline': require('./pbauthentication/1.0/change-password-pbOnline/success.json'),
      'get-encryption-params-pbOnline': require('./pbauthentication/1.0/get-encryption-params-pbOnline/success.json'),
      'enroll-device': require('./pbauthentication/1.0/enroll-device/success.json'),
      'disenroll-device': require('./pbauthentication/1.0/disenroll-device/success.json'),
      'validate-device': require('./pbauthentication/1.0/validate-device/success.json'),
    }
  },
  'alternatives': {
    '1.0': {
      'alternatives-positions': require('./alternatives/1.0/alternatives-positions/success.json'),
      'alternatives-transactions': require('./alternatives/1.0/alternatives-transactions/success.json'),
      'alternatives-value-movement': require('./alternatives/1.0/alternatives-value-movement/success.json'),
    }
  },
  'bonds': {
    '1.0': {
      'bonds-positions': require('./bonds/1.0/bonds-positions/success.json'),
      'bonds-transactions': require('./bonds/1.0/bonds-transactions/success.json'),
      'bonds-value-movement': require('./bonds/1.0/bonds-value-movement/success.json'),
    }
  },
  'cash': {
    '1.0': {
      'cash-positions': require('./cash/1.0/cash-positions/success.json'),
      'cash-transactions': require('./cash/1.0/cash-transactions/success.json'),
      'cash-value-movement': require('./cash/1.0/cash-value-movement/success.json'),
      'cash-positions-payments': require('./cash/1.0/cash-positions-payments/success.json'),
    }
  },
  'options': {
    '1.0': {
      'options-positions': require('./options/1.0/options-positions/success.json'),
      'options-transactions': require('./options/1.0/options-transactions/success.json'),
      'options-value-movement': require('./options/1.0/options-value-movement/success.json'),
    }
  },
  'fx-forwards': {
    '1.0': {
      'fx-forwards-positions': require('./fx-forwards/1.0/fx-forwards-positions/success.json'),
      'fx-forwards-transactions': require('./fx-forwards/1.0/fx-forwards-transactions/success.json'),
      'fx-forwards-value-movement': require('./fx-forwards/1.0/fx-forwards-value-movement/success.json'),
    }
  },
  'loan': {
    '1.0': {
      'loan-positions': require('./loan/1.0/loan-positions/success.json'),
      'loan-transactions': require('./loan/1.0/loan-transactions/success.json'),
    }
  },
  'maturities': {
    '1.0': {
      'maturity-bonds-details': require('./maturities/1.0/maturity-bonds-details/success.json'),
      'maturity-dci-details': require('./maturities/1.0/maturity-dci-details/success.json'),
      'maturity-deposits-details': require('./maturities/1.0/maturity-deposits-details/success.json'),
      'maturity-fx-forwards-details': require('./maturities/1.0/maturity-fx-forwards-details/success.json'),
      'maturity-loan-details': require('./maturities/1.0/maturity-loan-details/success.json'),
      'maturity-in-next-one-year': require('./maturities/1.0/maturity-in-next-one-year/success.json'),

      'maturity-bonds-details-week': require('./maturities/1.0/maturity-bonds-details/week.json'),
      'maturity-dci-details-week': require('./maturities/1.0/maturity-dci-details/week.json'),
      'maturity-deposits-details-week': require('./maturities/1.0/maturity-deposits-details/week.json'),
      'maturity-fx-forwards-details-week': require('./maturities/1.0/maturity-fx-forwards-details/week.json'),
      'maturity-loan-details-week': require('./maturities/1.0/maturity-loan-details/week.json'),

      'maturity-bonds-details-month': require('./maturities/1.0/maturity-bonds-details/month.json'),
      'maturity-dci-details-month': require('./maturities/1.0/maturity-dci-details/month.json'),
      'maturity-deposits-details-month': require('./maturities/1.0/maturity-deposits-details/month.json'),
      'maturity-fx-forwards-details-month': require('./maturities/1.0/maturity-fx-forwards-details/month.json'),
      'maturity-loan-details-month': require('./maturities/1.0/maturity-loan-details/month.json'),
      "maturity-details": require('./maturities/1.0/maturity-details/success.json'),
    }
  },
  'equities': {
    '1.0': {
      'equity-positions': require('./equities/1.0/equity-positions/success.json'),
      'equity-transactions': require('./equities/1.0/equity-transactions/success.json'),
      'equity-value-movement': require('./equities/1.0/equity-value-movement/success.json'),
    }
  },
  'money-market': {
    '1.0': {
      'money-market-positions': require('./money-market/1.0/money-market-positions/success.json'),
      'money-market-transactions': require('./money-market/1.0/money-market-transactions/success.json'),
    }
  },
  'portfoliooverview': {
    '1.0': {
      'get-user-portfolio-summary': require('./portfoliooverview/1.0/get-user-portfolio-summary/success.json'),
      'asset-market-value': require('./portfoliooverview/1.0/asset-market-value/success.json'),
      'overall-market-value': require('./portfoliooverview/1.0/overall-market-value/success.json'),
      'portfolio-value-movement': require('./portfoliooverview/1.0/portfolio-value-movement/success.json'),
      'user-portfolio-relations': require('./portfoliooverview/1.0/user-portfolio-relations/success.json'),
      'save-user-rel-portfolio-selection': require('./portfoliooverview/1.0/save-user-rel-portfolio-selection/success.json'),
      'portfolio-performance': require('./portfoliooverview/1.0/portfolio-performance/success.json'),
      'collateral-surplus': require('./portfoliooverview/1.0/collateral-surplus/success.json'),
      'portfolio-currency-exposure': require('./portfoliooverview/1.0/portfolio-currency-exposure/success.json'),
      'groupasset-positions': require('./portfoliooverview/1.0/groupasset-positions/success.json'),
      'portfolios-cashaccounts': {
        'search': require('./portfoliooverview/1.0/portfolios-cashaccounts/search/success.json')
      }
    }
  },
  'various': {
    '1.0': {
      'various-positions': require('./various/1.0/various-positions/success.json'),
      'various-transactions': require('./various/1.0/various-transactions/success.json'),
      'various-value-movement': require('./various/1.0/various-value-movement/success.json'),
    }
  },
  'entitlement': {
    '1.0': {
      'user-entitlement': require('./entitlement/1.0/user-entitlement/success.json'),
      'processRulesForUserEntitlement': require('./entitlement/1.0/processRulesForUserEntitlement/success.json'),
      'entitlement-user-pf': require('./entitlement/1.0/entitlement-user-pf/success.json'),
    }
  },
  'netincomehistory': {
    '1.0': {
      'income-history-aggregate': require('./netincomehistory/1.0/income-history-aggregate/success.json'),
      'income-expense-transactions': require('./netincomehistory/1.0/income-expense-transactions/success.json'),
    }
  },
  'userprofile': {
    '1.0': {
      'set-user-pref-refccy': require('./userprofile/1.0/set-user-pref-refccy/success.json'),
      'get-user-pref-refccy': require('./userprofile/1.0/get-user-pref-refccy/success.json'),
      'save-user-discovery-status': require('./userprofile/1.0/save-user-discovery-status/success.json'),
      'user-discovery-status': require('./userprofile/1.0/user-discovery-status/success.json'),
      'get-adu-admin-configs': require('./userprofile/1.0/get-adu-admin-configs/success.json'),
      'user-rmia-details': require('./userprofile/1.0/user-rmia-details/success.json'),
      'submit-feedback': require('./userprofile/1.0/submit-feedback/success.json'),
      'submit-star-feedback': require('./userprofile/1.0/submit-star-feedback/success.json'),
      'show-star-feedback': require('./userprofile/1.0/show-star-feedback/success.json'),
      'get-all-adu-admin-configs': require('./userprofile/1.0/get-all-adu-admin-configs/success.json'),
      'save-adu-admin-configs': require('./userprofile/1.0/save-adu-admin-configs/success.json'),
      'show-tcpa': require('./userprofile/1.0/show-tcpa/success.json'),
      'show-termsconditions': require('./userprofile/1.0/show-termsconditions/success.json'),
      'save-termsconditions': require('./userprofile/1.0/save-termsconditions/success.json'),
      'get-user-pref-edelivery': require('./userprofile/1.0/get-user-pref-edelivery/success.json'),
      'save-user-pref-edelivery': require('./userprofile/1.0/save-user-pref-edelivery/success.json'),
      'fetchUserPaymentTxLimit': require('./userprofile/1.0/fetchUserPaymentTxLimit/success.json'),
      'setUserPreferredLanguage': require('./userprofile/1.0/setUserPreferredLanguage/success.json'),
      'alerts': require('./userprofile/1.0/alerts/success.json'),
      'userDetails': {
        'get': require('./userprofile/1.0/userDetails/get/success.json'),
        'get-pf-relid-map': require('./userprofile/1.0/userDetails/get-pf-relid-map/success.json')

      },
      'userDetailsPref': {
        'save': require('./userprofile/1.0/userDetailsPref/save/success.json'),
      },
      'saveFileDownloadConsent':require('./userprofile/1.0/saveFileDownloadConsent/success.json'),
      'downtime': {
        'app': require('./userprofile/1.0/downtime/app/success.json')
      }
    }
  },
  'rsaauthentication': {
    '1.0': {
      'rsa-authentication': require('./rsaauthentication/1.0/rsa-authentication/success.json'),
    }
  },
  'reports': {
    '1.0': {
      'last-monthly-daily-statement': require('./reports/1.0/last-monthly-daily-statement/success.json'),
      'monthly-daily-statements': require('./reports/1.0/monthly-daily-statements/success.json'),
      'monthly-statements-overview': require('./reports/1.0/monthly-statements-overview/success.json'),
      'reports-details': require('./reports/1.0/reports-details/success.json'),
      'reports-overview': require('./reports/1.0/reports-overview/success.json'),
      'view-metadata': require('./reports/1.0/view-metadata/success.json'),
      'view-pdf': require('./reports/1.0/view-pdf/success.json'),
      'view-transaction': require('./reports/1.0/view-transaction/success.json'),
      'transaction-advices': require('./reports/1.0/transaction-advices/success.json'),
      'customReports-transaction-view': require('./reports/1.0/customReports-transaction-view/success.json'),
    }
  },
  'cioinsights': {
    '1.0': {
      'dashboard': require('./cioinsights/1.0/dashboard/success.json'),
      'publication': require('./cioinsights/1.0/publication/success.json'),
      'fetch-doc': require('./cioinsights/1.0/fetch-doc/success.json')
    }
  },
  'alertsandnotifications': {
    '1.0': {
      'get-user-notifications': require('./alertsandnotifications/1.0/get-user-notifications/success.json'),
      'set-as-read-user-notifications': require('./alertsandnotifications/1.0/set-as-read-user-notifications/success.json'),
      'get-user-pref-notifications': require('./alertsandnotifications/1.0/get-user-pref-notifications/success.json'),
      'save-user-pref-notifications': require('./alertsandnotifications/1.0/save-user-pref-notifications/success.json'),
    }
  },
  'crmintegration': {
    '1.0': {
      'send-rm-callback': require('./crmintegration/1.0/send-rm-callback/success.json'),
    }
  },
  'feedback': {
    '1.0': {
      'submit-feedback': require('./feedback/1.0/submit-feedback/success.json'),
      'show-star-feedback': require('./feedback/1.0/show-star-feedback/success.json'),
    }
  },
  'globalauth': {
    '1.0': {
      'generateActPwdAndRegId': require('./globalauth/1.0/generateActPwdAndRegId/success.json'),
      'generateServerEphPubKey': require('./globalauth/1.0/generateServerEphPubKey/success.json'),
      'generateServerEvidenceMessage': require('./globalauth/1.0/generateServerEvidenceMessage/success.json'),
      'activateDevice': require('./globalauth/1.0/activateDevice/success.json'),
      'verifyDeviceSignature': require('./globalauth/1.0/verifyDeviceSignature/success.json'),
      'verifyOTP': require('./globalauth/1.0/verifyOTP/success.json'),
      'handleSecondFactorStatus': require('./globalauth/1.0/handleSecondFactorStatus/success.json'),
      'getSecondFactorAuthServerTime': require('./globalauth/1.0/getSecondFactorAuthServerTime/success.json'),
      'setUserLoginAlias': require('./globalauth/1.0/setUserLoginAlias/success.json'),
      'getEncryptionToken': require('./globalauth/1.0/getEncryptionToken/success.json'),
      'authenticate': require('./globalauth/1.0/authenticate/success.json'),
      'changeProfilePassword': require('./globalauth/1.0/changeProfilePassword/success.json'),
      'updateActivationStatus': require('./globalauth/1.0/updateActivationStatus/success.json'),
      'deactivateSecondFactor': require('./globalauth/1.0/deactivateSecondFactor/success.json'),
      'auditSecondfactorEventLog': require('./globalauth/1.0/auditSecondFactorEventLog/success.json'),
      'authorizeWebSSOUser': require('./globalauth/1.0/authorizeWebSSOUser/success.json'),
      'sendResetCode': require('./globalauth/1.0/sendResetCode/success.json'),
      'verifyResetCode': require('./globalauth/1.0/verifyResetCode/success.json'),
      'resendResetCode': require('./globalauth/1.0/resendResetCode/success.json'),
      'changePassword': require('./globalauth/1.0/changePassword/success.json'),
      'registerViaSMS': require('./globalauth/1.0/registerViaSMS/success.json'),
      'validateSMSAuthCode': require('./globalauth/1.0/validateSMSAuthCode/success.json'),
      'initiateResetPin': require('./globalauth/1.0/initiateResetPin/success.json'),
      'generateAuthCodeForECred': require('./globalauth/1.0/generateAuthCodeForECred/success.json'),
      'validateECredAuthCode': require('./globalauth/1.0/validateECredAuthCode/success.json'),
      'updateECredStatus': require('./globalauth/1.0/updateECredStatus/success.json'),
      'initiateResetPassword': require('./globalauth/1.0/initiateResetPassword/success.json'),
      'generateTempPassword': require('./globalauth/1.0/generateTempPassword/success.json'),
      'maturity-bonds-details-month': require('./maturities/1.0/maturity-bonds-details/month.json'),
      'maturity-dci-details-month': require('./maturities/1.0/maturity-dci-details/month.json'),
      'maturity-deposits-details-month': require('./maturities/1.0/maturity-deposits-details/month.json'),
      'maturity-fx-forwards-details-month': require('./maturities/1.0/maturity-fx-forwards-details/month.json'),
      'maturity-loan-details-month': require('./maturities/1.0/maturity-loan-details/month.json'),
      "maturity-details": require('./maturities/1.0/maturity-details/success.json'),
    }
  },
  'equities': {
    '1.0': {
      'equity-positions': require('./equities/1.0/equity-positions/success.json'),
      'equity-transactions': require('./equities/1.0/equity-transactions/success.json'),
      'equity-value-movement': require('./equities/1.0/equity-value-movement/success.json'),
    }
  },
  'money-market': {
    '1.0': {
      'money-market-positions': require('./money-market/1.0/money-market-positions/success.json'),
      'money-market-transactions': require('./money-market/1.0/money-market-transactions/success.json'),
    }
  },
  'portfoliooverview': {
    '1.0': {
      'get-user-portfolio-summary': require('./portfoliooverview/1.0/get-user-portfolio-summary/success.json'),
      'asset-market-value': require('./portfoliooverview/1.0/asset-market-value/success.json'),
      'overall-market-value': require('./portfoliooverview/1.0/overall-market-value/success.json'),
      'portfolio-value-movement': require('./portfoliooverview/1.0/portfolio-value-movement/success.json'),
      'user-portfolio-relations': require('./portfoliooverview/1.0/user-portfolio-relations/success.json'),
      'save-user-rel-portfolio-selection': require('./portfoliooverview/1.0/save-user-rel-portfolio-selection/success.json'),
      'portfolio-performance': require('./portfoliooverview/1.0/portfolio-performance/success.json'),
      'collateral-surplus': require('./portfoliooverview/1.0/collateral-surplus/success.json'),
      'portfolio-currency-exposure': require('./portfoliooverview/1.0/portfolio-currency-exposure/success.json'),
      'groupasset-positions': require('./portfoliooverview/1.0/groupasset-positions/success.json'),
      'portfolios-cashaccounts': {
        'search': require('./portfoliooverview/1.0/portfolios-cashaccounts/search/success.json')
      },
      'getRTCashAccList': require('./portfoliooverview/1.0/getRTCashAccList/success.json'),
      'getRTCashAccDetails': require('./portfoliooverview/1.0/getRTCashAccDetails/success.json'),
    }
  },
  'various': {
    '1.0': {
      'various-positions': require('./various/1.0/various-positions/success.json'),
      'various-transactions': require('./various/1.0/various-transactions/success.json'),
      'various-value-movement': require('./various/1.0/various-value-movement/success.json'),
    }
  },
  'entitlement': {
    '1.0': {
      'user-entitlement': require('./entitlement/1.0/user-entitlement/success.json'),
      'processRulesForUserEntitlement': require('./entitlement/1.0/processRulesForUserEntitlement/success.json'),
      'entitlement-user-pf': require('./entitlement/1.0/entitlement-user-pf/success.json'),
      'admin-user-entitlement': require('./entitlement/1.0/admin-user-entitlement/success.json')
    }
  },
  'netincomehistory': {
    '1.0': {
      'income-history-aggregate': require('./netincomehistory/1.0/income-history-aggregate/success.json'),
      'income-expense-transactions': require('./netincomehistory/1.0/income-expense-transactions/success.json'),
    }
  },
  'userprofile': {
    '1.0': {
      'set-user-pref-refccy': require('./userprofile/1.0/set-user-pref-refccy/success.json'),
      'get-user-pref-refccy': require('./userprofile/1.0/get-user-pref-refccy/success.json'),
      'save-user-discovery-status': require('./userprofile/1.0/save-user-discovery-status/success.json'),
      'user-discovery-status': require('./userprofile/1.0/user-discovery-status/success.json'),
      'get-adu-admin-configs': require('./userprofile/1.0/get-adu-admin-configs/success.json'),
      'user-rmia-details': require('./userprofile/1.0/user-rmia-details/success.json'),
      'submit-feedback': require('./userprofile/1.0/submit-feedback/success.json'),
      'submit-star-feedback': require('./userprofile/1.0/submit-star-feedback/success.json'),
      'show-star-feedback': require('./userprofile/1.0/show-star-feedback/success.json'),
      'get-all-adu-admin-configs': require('./userprofile/1.0/get-all-adu-admin-configs/success.json'),
      'save-adu-admin-configs': require('./userprofile/1.0/save-adu-admin-configs/success.json'),
      'show-tcpa': require('./userprofile/1.0/show-tcpa/success.json'),
      'show-termsconditions': require('./userprofile/1.0/show-termsconditions/success.json'),
      'save-termsconditions': require('./userprofile/1.0/save-termsconditions/success.json'),
      'get-user-pref-edelivery': require('./userprofile/1.0/get-user-pref-edelivery/success.json'),
      'save-user-pref-edelivery': require('./userprofile/1.0/save-user-pref-edelivery/success.json'),
      'fetchUserPaymentTxLimit': require('./userprofile/1.0/fetchUserPaymentTxLimit/success.json'),
      'setUserPreferredLanguage': require('./userprofile/1.0/setUserPreferredLanguage/success.json'),
      'alerts': require('./userprofile/1.0/alerts/success.json'),
      'userDetails': {
        'get': require('./userprofile/1.0/userDetails/get/success.json'),
        'get-pf-relid-map': require('./userprofile/1.0/userDetails/get-pf-relid-map/success.json'),

      },
      'userDetailsPref': {
        'save': require('./userprofile/1.0/userDetailsPref/save/success.json'),
      },
      'downtime': {
        'app': require('./userprofile/1.0/downtime/app/success.json')
      }
    }
  },
  'multisig-service':{
    '1.0': {
      'approver': {
        'multisig-payment':{
          'validate': require('./multisig-service/1.0/approver/multisig-payment/validate/success.json')
        }
      },
      'user':{
        'notifications':{
           'fetch': require('./multisig-service/1.0/user/notifications/fetch/success.json')
        }
      }
    },
  },
  'rsaauthentication': {
    '1.0': {
      'rsa-authentication': require('./rsaauthentication/1.0/rsa-authentication/success.json'),
    }
  },
  'reports': {
    '1.0': {
      'last-monthly-daily-statement': require('./reports/1.0/last-monthly-daily-statement/success.json'),
      'monthly-daily-statements': require('./reports/1.0/monthly-daily-statements/success.json'),
      'monthly-statements-overview': require('./reports/1.0/monthly-statements-overview/success.json'),
      'reports-details': require('./reports/1.0/reports-details/success.json'),
      'reports-overview': require('./reports/1.0/reports-overview/success.json'),
      'view-metadata': require('./reports/1.0/view-metadata/success.json'),
      'view-pdf': require('./reports/1.0/view-pdf/success.json'),
      'view-transaction': require('./reports/1.0/view-transaction/success.json'),
      'transaction-advices': require('./reports/1.0/transaction-advices/success.json'),
      'customReports-transaction-view': require('./reports/1.0/customReports-transaction-view/success.json'),
    }
  },
  'cioinsights': {
    '1.0': {
      'dashboard': require('./cioinsights/1.0/dashboard/success.json'),
      'publication': require('./cioinsights/1.0/publication/success.json'),
      'fetch-doc': require('./cioinsights/1.0/fetch-doc/success.json')
    }
  },
  'alertsandnotifications': {
    '1.0': {
      'get-user-notifications': require('./alertsandnotifications/1.0/get-user-notifications/success.json'),
      'set-as-read-user-notifications': require('./alertsandnotifications/1.0/set-as-read-user-notifications/success.json'),
      'get-user-pref-notifications': require('./alertsandnotifications/1.0/get-user-pref-notifications/success.json'),
      'save-user-pref-notifications': require('./alertsandnotifications/1.0/save-user-pref-notifications/success.json'),
    }
  },
  'crmintegration': {
    '1.0': {
      'send-rm-callback': require('./crmintegration/1.0/send-rm-callback/success.json'),
    }
  },
  'feedback': {
    '1.0': {
      'submit-feedback': require('./feedback/1.0/submit-feedback/success.json'),
      'show-star-feedback': require('./feedback/1.0/show-star-feedback/success.json'),
    }
  },
  'globalauth': {
    '1.0': {
      'generateActPwdAndRegId': require('./globalauth/1.0/generateActPwdAndRegId/success.json'),
      'generateServerEphPubKey': require('./globalauth/1.0/generateServerEphPubKey/success.json'),
      'generateServerEvidenceMessage': require('./globalauth/1.0/generateServerEvidenceMessage/success.json'),
      'activateDevice': require('./globalauth/1.0/activateDevice/success.json'),
      'verifyDeviceSignature': require('./globalauth/1.0/verifyDeviceSignature/success.json'),
      'verifyOTP': require('./globalauth/1.0/verifyOTP/success.json'),
      'handleSecondFactorStatus': require('./globalauth/1.0/handleSecondFactorStatus/success.json'),
      'getSecondFactorAuthServerTime': require('./globalauth/1.0/getSecondFactorAuthServerTime/success.json'),
      'setUserLoginAlias': require('./globalauth/1.0/setUserLoginAlias/success.json'),
      'getEncryptionToken': require('./globalauth/1.0/getEncryptionToken/success.json'),
      'authenticate': require('./globalauth/1.0/authenticate/success.json'),
      'changeProfilePassword': require('./globalauth/1.0/changeProfilePassword/success.json'),
      'updateActivationStatus': require('./globalauth/1.0/updateActivationStatus/success.json'),
      'deactivateSecondFactor': require('./globalauth/1.0/deactivateSecondFactor/success.json'),
      'auditSecondfactorEventLog': require('./globalauth/1.0/auditSecondFactorEventLog/success.json'),
      'authorizeWebSSOUser': require('./globalauth/1.0/authorizeWebSSOUser/success.json'),
      'sendResetCode': require('./globalauth/1.0/sendResetCode/success.json'),
      'verifyResetCode': require('./globalauth/1.0/verifyResetCode/success.json'),
      'resendResetCode': require('./globalauth/1.0/resendResetCode/success.json'),
      'changePassword': require('./globalauth/1.0/changePassword/success.json'),
      'registerViaSMS': require('./globalauth/1.0/registerViaSMS/success.json'),
      'validateSMSAuthCode': require('./globalauth/1.0/validateSMSAuthCode/success.json'),
      'initiateResetPin': require('./globalauth/1.0/initiateResetPin/success.json'),
      'generateAuthCodeForECred': require('./globalauth/1.0/generateAuthCodeForECred/success.json'),
      'validateECredAuthCode': require('./globalauth/1.0/validateECredAuthCode/success.json'),
      'updateECredStatus': require('./globalauth/1.0/updateECredStatus/success.json'),
      'initiateResetPassword': require('./globalauth/1.0/initiateResetPassword/success.json'),
      'generateTempPassword': require('./globalauth/1.0/generateTempPassword/success.json'),
      'logout': require('./globalauth/1.0/logout/success.json'),
      'updatePassword': require('./globalauth/1.0/updatePassword/success.json'),
      'initiateChangePassword': require('./globalauth/1.0/initiateChangePassword/success.json')
    }
  },
  'position-search': {
    '1.0': {
      'get-recent-search': require('./position-search/1.0/get-recent-search/success.json'),
      'search-position': require('./position-search/1.0/search-position/success.json'),
      'save-recent-search': require('./position-search/1.0/save-recent-search/success.json'),
    }
  },
  'excelexports': {
    '1.0': {
      'excel-content': require('./excelexports/1.0/excel-content/success.json'),
      'initiate-dataextract': require('./excelexports/1.0/initiateDataExtract/success.json'),
      'get-extract-volume': require('./excelexports/1.0/getExtractVolume/success.json'),
      'get-distinct-dates': require('./excelexports/1.0/getDistinctDates/success.json'),
    }
  },

  'investmentidea': {
    '1.0': {
      'investmentIdeas': require('./investmentidea/1.0/investmentIdeas/success.json'),
      'investmentIdeasAssets': require('./investmentidea/1.0/investmentIdeasAssets/success.json'),
      'investmentIdeasDetails': require('./investmentidea/1.0/investmentIdeasDetails/success.json'),
      'searchInvestmentIdeas': require('./investmentidea/1.0/searchInvestmentIdeas/success.json'),
    }
  },

  'transactions': {
    '1.0': {
      'initializeTx': require('./transactions/1.0/initializeTx/success.json'),
      'generateTxChallenge': require('./transactions/1.0/generateTxChallenge/success.json'),
      'verifyChallengeResponse': require('./transactions/1.0/verifyChallengeResponse/success.json'),
      'cancelTx': require('./transactions/1.0/cancelTx/success.json'),
      'fetchTx': require('./transactions/1.0/fetchTx/success.json'),
      'fetchWebTx': require('./transactions/1.0/fetchWebTx/success.json'),
      'txRefresh': require('./transactions/1.0/txRefresh/success.json'),
      'rejectTx': require('./transactions/1.0/rejectTx/success.json'),
    }
  },
  'multisig-service':{
    '1.0': {
      'approver': {
        'multisig-payment':{
          'validate': require('./multisig-service/1.0/approver/multisig-payment/validate/success.json'),
          'resume': require('./multisig-service/1.0/approver/multisig-payment/resume/success.json'),
        }
      },
      'user':{
        'notifications':{
           'fetch': require('./multisig-service/1.0/user/notifications/fetch/success.json')
        }
      }
    },
  },
  'payments': {
    '1.0': {
      'bankDetailsLookup': require('./payments/1.0/bankDetailsLookup/success.json'),
      'searchCountry': require('./payments/1.0/searchCountry/success.json'),
      'listTransactions': require('./payments/1.0/listTransactions/success.json'),
      'filterListsLookup': require('./payments/1.0/filterListsLookup/success.json'),
      'addBeneficiary': require('./payments/1.0/addBeneficiary/success.json'),
      'beneficiaryList': require('./payments/1.0/beneficiaryList/success.json'),
      'updateBeneficiary': require('./payments/1.0/updateBeneficiary/success.json'),
      'deleteBeneficiary': require('./payments/1.0/deleteBeneficiary/success.json'),
      'templateList': require('./payments/1.0/templateList/success.json'),
      'deleteTemplate': require('./payments/1.0/deleteTemplate/success.json'),
      'updatePaymentTemplate': require('./payments/1.0/updatePaymentTemplate/success.json'),
      'listStandingOrderTx': require('./payments/1.0/listStandingOrderTx/success.json'),
      'viewPaymentOrder': require('./payments/1.0/viewPaymentOrder/success.json'),
    }
  },
  'payment': {
    '1.0': {
      'beneficiary': {
        'validate': require('./payment/1.0/beneficiary/validate/success.json'),
        'list': require('./payment/1.0/beneficiary/list/success.json')
      },
      'payments': {
        'beneficiaries': {
          'validate': require('./payment/1.0/payments/beneficiaries/validate/success.json'),
        }
      },
      'beneficiaries': {
        'names': {
          'patch': require('./payment/1.0/beneficiaries/names/patch/success.json'),
        }
      }
    }
  },
  'edelivery': {
    '1.0': {
      'initializeEDelivery': require('./edeliverych/1.0/initializeEDelivery/success.json'),
      'downloadDocuments': require('./edeliverych/1.0/downloadDocuments/success.json'),
      'markDocumentsAsRead': require('./edeliverych/1.0/markDocumentsAsRead/success.json'),
      'fetchDocumentsForCategories': require('./edeliverych/1.0/fetchDocumentsForCategories/success.json'),
      'fetchDocumentsForOrder': require('./edeliverych/1.0/fetchDocumentsForOrder/success.json'),
      'documents': {
        'orders': {
          'categories': {
            'fetch': require('./edeliverych/1.0/documents/orders/categories/fetch/success.json')
          }
        },
        'reports':{
          'adhoc': {
            'create': require('./edeliverych/1.0/documents/reports/adhoc/create/success.json')
          }
        }
      },
      'reports':{
        'statement-types': {
          'fetch': require('./edeliverych/1.0/reports/statement-types/success.json')
        },
      }
    }
  },
  'digisign': {
    '1.0': {
      'showUserBanner': require('./digisign/1.0/showUserBanner/success.json'),
      'saveUserSeenBanner': require('./digisign/1.0/saveUserSeenBanner/success.json'),
      'templateDropDown': require('./digisign/1.0/templateDropDown/success.json'),
      'eligiblePfSign': require('./digisign/1.0/eligiblePfSign/success.json'),
      'eligibleClientSign': require('./digisign/1.0/eligibleClientSign/success.json'),
      'listEnvelope': require('./digisign/1.0/listEnvelope/success.json'),
      'manageUserDsDoc': require('./digisign/1.0/manageUserDsDoc/success.json'),
      'getClientSub': require('./digisign/1.0/getClientSub/success.json'),
      'saveClientSub': require('./digisign/1.0/saveClientSub/success.json'),
      'viewClientDsDoc': require('./digisign/1.0/viewClientDsDoc/success.json'),
      'dsAcceptView': require('./digisign/1.0/dsAcceptView/success.json'),
      'dsActionAccept': require('./digisign/1.0/dsActionAccept/success.json'),
      'dsRecipientView': require('./digisign/1.0/dsRecipientView/success.json'),
      'completeSignature': require('./digisign/1.0/completeSignature/success.json'),
      'viewSignedDoc': require('./digisign/1.0/viewSignedDoc/success.json'),
      'getRmTeamList': require('./digisign/1.0/getRmTeamList/success.json'),
      'getRmNames': require('./digisign/1.0/getRmNames/success.json'),
      'getClientNames': require('./digisign/1.0/getClientNames/success.json'),
      'getOrderIdList': require('./digisign/1.0/getOrderIdList/success.json'),
      'getDocumentNameList': require('./digisign/1.0/getDocumentNameList/success.json')
    }
  },
  'chatservices': {
    '1.0': {
      'fetchUserList': require('./chatservices/1.0/fetchUserList/success.json'),
      'fetchChatHistory': require('./chatservices/1.0/fetchChatHistory/success.json')
    }
  },
  'pushnotification': {
    '1.0': {
      'pushRegistration': require('./pushnotification/1.0/pushRegistration/success.json'),
      'getFCMSenderId': require('./pushnotification/1.0/getFCMSenderId/success.json')
    }
  },
  'trades': {
    '1.0': {
      'trades': {
        'search': require('./trades/1.0/trades/search/success.json'),
        'cancel': require('./trades/1.0/trades/cancel/success.json'),
        'approve': require('./trades/1.0/trades/approve/success.json')
      },
      'assets': {
        'search': require('./trades/1.0/assets/search/success.json'),
        'get': require('./trades/1.0/assets/get/success.json'),
        'lookup': require('./trades/1.0/assets/lookup/success.json')
      },
      'statuses': require('./trades/1.0/statuses/success.json')
    }
  },
  'usermgmt': {
    '1.0': {
      'userId': require('./user-management/1.0/userId/success.json'),
      'getSmartCardUrl': require('./user-management/1.0/getSmartCardUrl/success.json')
    }
  },
  'rmaccess': {
    '1.0': {
      'upload': {
        'initialize': require('./rmaccess/1.0/upload/initialize/success.json'),
        'finalize': require('./rmaccess/1.0/upload/finalize/success.json'),
        'history': require('./rmaccess/1.0/upload/history/success.json')
      },
      'contract': {
        'search': require('./rmaccess/1.0/contract/search/success.json')
      },
      'initiate-session': require('./rmaccess/1.0/initiate-session/success.json'),
      'getcontracts': require('./rmaccess/1.0/getcontracts/success.json'),
      'rm-client-session-logout': require('./rmaccess/1.0/rm-client-session-logout/success.json')
    }
  },
  'contactdetailsservice': {
    '1.0': {
      'business-partners': {
        'fetch': require('./contactdetailsservice/1.0/business-partners/fetch/success.json')
      },
      'contacts': {
        'fetch': require('./contactdetailsservice/1.0/contacts/fetch/success.json'),
        'save': require('./contactdetailsservice/1.0/contacts/save/success.json'),
        'sign': require('./contactdetailsservice/1.0/contacts/sign/success.json'),
      },
      'hrmw-options': {
        'accept': require('./contactdetailsservice/1.0/hrmw-options/accept/success.json')
      },
    }
  },
  'psd2aiscservice':{
    '1.0':{
      'consents':{
        'ais':{
          'get': require('./psd2aiscservice/1.0/consents/ais/get/success.json'),
          'update': require('./psd2aiscservice/1.0/consents/ais/update/success.json')
        },
        'fetch': require('./psd2aiscservice/1.0/consents/fetch/success.json')
      }
    }
  },

  'psd2pisservice':{
    '1.0':{
        'payments': {
          'get': require('./psd2pisservice/1.0/payments/get/success.json'),
          'update':require('./psd2pisservice/1.0/payments/update/success.json')
        },
        'confirmed-payments': {
          'get': require('./psd2pisservice/1.0/confirmed-payments/get/success.json'),
          'update':require('./psd2pisservice/1.0/confirmed-payments/update/success.json')
        }
    }
  }

};

